<template>
  <v-navigation-drawer
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list dense>
      <template v-for="item in displayableItems">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']"
          append-icon
        >
          <template v-slot:activator>
            <v-list-item :to="item.to" link>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.to"
            link
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.to" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data: () => ({
    items: [
      {
        icon: 'mdi-cash-multiple',
        text: 'Financial',
        to: { name: 'Invoices' },
      },
      // {
      //   icon: 'mdi-cash-clock',
      //   text: 'Payments',
      //   to: { name: 'Payments' },
      // },
      {
        icon: 'mdi-cash-clock',
        text: 'Payments',
        to: { name: 'Payments' },
      },
      {
        icon: 'mdi-account-check-outline',
        text: 'Enrollments',
        to: { name: 'Enrollment' },
      },
      {
        icon: 'mdi-account-group',
        text: 'Attendance',
        to: { name: 'Attendance' },
      },
      {
        icon: 'mdi-account-group',
        text: 'Monthly Attendance',
        to: { name: 'MonthlyAttendance' },
      },
      // {
      //   icon: 'mdi-checkbox-multiple-marked',
      //   text: 'Daily Checklist',
      //   to: { name: 'ChecklistDaily' },
      // },
      {
        icon: 'mdi-checkbox-multiple-marked',
        text: 'Daily Checklist Summary',
        to: { name: 'ChecklistDailySummary' },
      },
      {
        icon: 'mdi-checkbox-multiple-marked',
        text: 'Student Checklist Summary',
        to: { name: 'ChecklistStudentSummary' },
      },
      {
        icon: 'mdi-checkbox-multiple-marked',
        text: 'Executive Checklist Summary',
        to: { name: 'ExecutiveChecklistSummary' },
      },
      {
        icon: 'mdi-note-check-outline',
        text: 'Test Prep',
        to: { name: 'TestPrep' },
      },
      {
        icon: 'mdi-account-multiple',
        text: 'Contacts',
        to: { name: 'contact' },
      },
      {
        icon: 'mdi-file-chart',
        text: 'Staff Timesheet',
        to: { name: 'Timesheet' },
      },
      {
        icon: 'mdi-cash-clock',
        text: 'Payroll And Scheduling',
        to: { name: 'PayrollAndScheduling' },
      },
      {
        icon: 'mdi-tools',
        text: 'Account Closing',
        to: { name: 'accountClosing' },
      },
    ],
  }),

  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser', 'userRoles']),
    ...mapGetters('navigation', ['navState']),
    displayableItems() {
      const allRoutes = this.$router.options.routes;
      return this.items.filter((item) => {
        let authorize = null;
        const route = allRoutes.find(
          (r) => r.path == item.link || r.name == item.to.name,
        );
        if (route && route.meta) {
          authorize = route.meta.authorize;
          return this.isLoggedIn && this.isAuthorized(authorize);
        } else if (!route) {
          console.warn('Uknown route found in Sidebar: ', item);
          return false;
        } else {
          return true; //include menu withtout authorize filter
        }
      });
    },
  },
  methods: {
    ...mapActions('messages', ['addErrorMessage']),
    isAuthorized(roles) {
      if (!roles || roles.length < 1) {
        return true;
      }
      if (this.userRoles && this.userRoles.length > 0) {
        return this.userRoles.some((r) => roles.includes(r));
      } else {
        this.addErrorMessage('Unauthorized Access');
        return false;
      }
    },
  },
};
</script>

<style></style>
